// Lote 101 — "Conferir na fonte": portal público de consulta processual por tribunal (alias do
// DataJud: trt15, tjsp…). Só o que tem endereço estável; para os demais o app apenas copia o número.
export function portalConsultaUrl(alias) {
  const a = (alias || "").toLowerCase();
  const trt = /^trt(\d{1,2})$/.exec(a);
  if (trt) return `https://pje.trt${parseInt(trt[1], 10)}.jus.br/consultaprocessual/`;
  if (a === "tjsp") return "https://esaj.tjsp.jus.br/cpopg/open.do";
  if (a === "tst") return "https://consultaprocessual.tst.jus.br/consultaProcessual/";
  return null;
}
